// This produces an iterable set of weak references
export default class WeakRefSet {
  constructor () {
    this.refs = new Set()

    // We cleanup when we access the list. This timed cleanup is just a
    // way to keep the size of this list tieded up for times it's not accessed
    // frequently.
    this.cleanupInterval = setInterval(() => this.cleanup(), 10 * 1000) // 10 seconds
  }

  add (obj) {
    // We don't add the same object twice, the set will not take care of it because
    // each ref is a different object
    if (this.getRef(obj)) return

    // eslint-disable-next-line no-undef
    this.refs.add(new WeakRef(obj))
  }

  delete (obj) {
    this.refs.delete(this.getRef(obj))
  }

  cleanup () {
    for (const ref of this.refs) {
      if (ref.deref() === undefined) {
        this.refs.delete(ref)
      }
    }
  }

  items () {
    const items = []
    for (const ref of this.refs) {
      const obj = ref.deref()
      if (obj !== undefined) {
        items.push(obj)
      } else {
        // Cleanup as we go
        this.refs.delete(ref)
      }
    }
    return items
  }

  destroy () {
    clearInterval(this.cleanupInterval)
    this.refs.clear()
  }

  getRef (obj) {
    for (const ref of this.refs) {
      if (ref.deref() === obj) {
        return ref
      }
    }
    return undefined
  }
}
